import { css } from 'styled-components'

const extendStylesDropdownOfficeV2 = css`
    /* width: 281px; */
    width: 220px;
`

export { extendStylesDropdownOfficeV2 }
